import firebase from 'firebase/app';

export interface t1 {
    x: number;
    y: number
}

export interface t2 {
    position: t1;
    time: number;
}

export interface t3 {
    color: number;
    width: number;
    points: t2[];
}

export interface t4 {
    paths: t3[];
    timestamp: firebase.firestore.FieldValue;
    country: string;
    prefecture: string;
    guide: number;
    eventType?:EventType;
    isDone:boolean;
}

export enum EventType{
    Workshop='ws',
    FreeSpace='fs'
}